import React from "react"
import PropTypes from "prop-types"
import DeviceUtilizationSummaryCard from "./DeviceUtilizationSummaryCard"
import UsageSnapshotCard from "./UsageSnapshotCard"

import "./UtilizationDetailCards.scss"

const UtilizationDetailCards = props => {
  return (
    <div className="UtilizationDetailCards">
      <DeviceUtilizationSummaryCard {...props} />
      <UsageSnapshotCard {...props} />
    </div>
  )
}

UtilizationDetailCards.propTypes = {
  maxInEntity: PropTypes.number,
  availableDuringPeak: PropTypes.number,
  avgUsage: PropTypes.number,
  peakUsageTrend: PropTypes.array,
}

export default UtilizationDetailCards
